export default __webpack_public_path__ + "static/media/SuperShadows_08.43302c65.png";